import { Flex } from '@shared/components';

import { useShortFormTemplateData } from '../../hooks';

import QuestionnaireReportShortFormSection from './questionnaire-report-short-form-section';

export default function QuestionnaireReportShortFormTemplate() {
  const { sections, loading } = useShortFormTemplateData();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      {sections.map((section) => (
        <QuestionnaireReportShortFormSection
          key={section.key}
          section={section}
          loading={loading}
        />
      ))}
    </Flex>
  );
}
